/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx';
import {toAbsoluteUrl} from '../../../helpers';
import {HeaderUserMenu} from '../../../partials';
import {useNavigate} from 'react-router-dom';
import styles from './Navbar.module.scss';
import {useNativeAuth} from '../../../../app/modules/auth/native/NativeAuthProvider';
import SecuredComponent from '../../../../app/modules/auth/authorization/SecuredComponent';
import {useIntl} from 'react-intl';
import {OverlayTrigger, Overlay, Tooltip} from 'react-bootstrap';
import {useRef, useState} from 'react';
import {useLang, setLanguage} from '../../../i18n/Metronici18n';
import CustomerScopeSwitcher from '../../../../Domains/Auth/Components/CustomerScopeSwitcher';

const languages = [
  {lang: 'fr', name: 'Français', flag: toAbsoluteUrl('/media/flags/france.svg')},
  {lang: 'en', name: 'English', flag: toAbsoluteUrl('/media/flags/united-kingdom.svg')},
  {lang: 'de', name: 'Deutsch', flag: toAbsoluteUrl('/media/flags/germany.svg')},
  {lang: 'es', name: 'Español', flag: toAbsoluteUrl('/media/flags/spain.svg')},
  {lang: 'it', name: 'Italiano', flag: toAbsoluteUrl('/media/flags/italy.svg')},
];

// const itemClass = 'ms-3 ms-lg-5';
const itemClass = 'px-3';
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-color-primary h-35px h-md-40px w-100';
// const userAvatarClass = 'symbol-35px symbol-md-40px';
// const btnIconClass = 'svg-icon-1';

const Navbar = () => {
  const navigate = useNavigate();
  const {claims} = useNativeAuth();
  const displayName = claims?.name as string;
  const displayEmail = claims?.preferred_username as string;
  const intl = useIntl();
  const profileTriggerRef = useRef<HTMLDivElement>(null);
  const [showProfileTooltip, setShowProfileTooltip] = useState(false);
  const lang = useLang();
  const currentLanguage = languages.find((x) => x.lang === lang);

  /**
   * Lien vers gestion des utilisateurs, actuellement (24/04/2024) la gestion des utilisateurs pour les clients desk fonctionne pas donc redirection vers l'ec desk
   * A changer quand la recup des bu sera active (back/app/Library/BU/Bu.php)
   */
  return (
    <div className={clsx('app-navbar justify-content-end', styles.containerNavbar)}>
      {/*Gestion log*/}
      <SecuredComponent requiredPermissions={['ecAdmin']} adminWithImpersonate={true}>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{intl.formatMessage({id: 'LOG.ACTION.LABEL'})}</Tooltip>}
        >
          <div
            className={clsx('app-navbar-item', itemClass)}
            onClick={() => {
              navigate('/History/log');
            }}
          >
            <div
              data-kt-menu-trigger="{default: 'click'}"
              data-kt-menu-attach="parent"
              data-kt-menu-placement="bottom-end"
              className={clsx(btnClass, 'd-flex align-items-center justify-content-center')}
            >
              <img
                src={toAbsoluteUrl('/media/avatars/history-log.png')}
                className="icon-item"
                alt=""
              />
            </div>
          </div>
        </OverlayTrigger>
      </SecuredComponent>

      {/* Gestion des utilisateurs */}
      <SecuredComponent requiredPermissions={['gestionnaireDeCompte']}>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{intl.formatMessage({id: 'NAVBAR.TOOLTIP.USER_MANAGER'})}</Tooltip>}
        >
          <div
            className={clsx(
              'app-navbar-item',
              itemClass,
              'border-start border-gray-300 borderStyles'
            )}
            onClick={() => {
              navigate('/settings/authorization');
            }}
          >
            <div
              data-kt-menu-trigger="{default: 'click'}"
              data-kt-menu-attach="parent"
              data-kt-menu-placement="bottom-end"
              className={clsx(btnClass, 'd-flex align-items-center justify-content-center')}
            >
              <img
                src={toAbsoluteUrl('/media/avatars/icon-users-manager.png')}
                className="icon-item"
                alt=""
              />
            </div>
          </div>
        </OverlayTrigger>
      </SecuredComponent>

      {/* Paramètres */}
      {/* <SecuredComponent requiredPermissions={['ecAdmin']}>
                <OverlayTrigger placement="bottom" overlay={<Tooltip>{intl.formatMessage({id: 'NAVBAR.TOOLTIP.SETTINGS'})}</Tooltip>}>
                    <div
                        className={clsx('app-navbar-item', itemClass, 'border-start border-gray-300 borderStyles')}
                        onClick={() => navigate('/admin')}
                    >
                        <div
                            data-kt-menu-trigger="{default: 'click'}"
                            data-kt-menu-attach="parent"
                            data-kt-menu-placement="bottom-end"
                            className={btnClass}
                        >
                            <img src={toAbsoluteUrl('/media/avatars/icon-param.png')} className="icon-item" alt=""/>
                        </div>
                    </div>
                </OverlayTrigger>
            </SecuredComponent> */}

      {/* Langue */}
      <div
        className={clsx('app-navbar-item', itemClass, 'border-start border-gray-300 borderStyles')}
      >
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          className={clsx(
            btnClass,
            'd-flex align-items-center justify-content-center cursor-pointer'
          )}
        >
          <img
            src={currentLanguage?.flag}
            className="w-20px h-20px rounded-circle"
            alt={currentLanguage?.name}
          />
        </div>
        <div
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-2 fs-6 w-175px"
          data-kt-menu="true"
        >
          {languages.map((l, index) => (
            <div key={l.lang}>
              <div className="menu-item">
                <a
                  href="#"
                  onClick={() => setLanguage(l.lang)}
                  className={clsx('menu-link px-6 py-1 rounded', {active: l.lang === lang})}
                  style={{
                    fontSize: '1rem',
                    fontWeight: 500,
                    color: '#1e1e1f',
                    fontFamily: 'Inter',
                  }}
                >
                  <img
                    src={l.flag}
                    className="rounded-circle me-3"
                    style={{width: '18px', height: '18px'}}
                    alt={l.name}
                  />
                  {l.name}
                </a>
              </div>
              {index < languages.length - 1 && <div className="separator my-2"></div>}
            </div>
          ))}
        </div>
      </div>

      {/* Client affiché : tous les clients ou un seul */}
      <CustomerScopeSwitcher
        className={clsx('app-navbar-item', itemClass, 'border-start border-gray-300 borderStyles')}
      />

      {/* Profil */}
      <div
        className={clsx('app-navbar-item', itemClass, 'border-start border-gray-300 borderStyles')}
      >
        <Overlay show={showProfileTooltip} placement="bottom" target={profileTriggerRef}>
          <Tooltip>{intl.formatMessage({id: 'NAVBAR.TOOLTIP.PROFILE'})}</Tooltip>
        </Overlay>
        <div
          ref={profileTriggerRef}
          className={clsx('cursor-pointer', 'd-flex align-items-center')}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          onMouseEnter={() => setShowProfileTooltip(true)}
          onMouseLeave={() => setShowProfileTooltip(false)}
          onClick={() => setShowProfileTooltip(false)}
        >
          <img
            src={toAbsoluteUrl('/media/avatars/icon-profile-01.png')}
            className="icon-item"
            alt=""
          />
          <div className="ms-3 d-none d-md-block">
            <span className="text-nowrap fw-bold">{displayName}</span>
            <br />
            <span className="text-nowrap">{displayEmail}</span>
          </div>
        </div>
        <HeaderUserMenu />
      </div>

      {/*{config.app?.header?.default?.menu?.display && (*/}
      {/*    <div className="app-navbar-item d-lg-none ms-2 me-n3" title="Show header menu">*/}
      {/*        <div*/}
      {/*            className="btn btn-icon btn-active-color-primary w-35px h-35px"*/}
      {/*            id="kt_app_header_menu_toggle"*/}
      {/*        >*/}
      {/*            <KTSVG*/}
      {/*                path="/media/icons/duotune/text/txt001.svg"*/}
      {/*                className={btnIconClass}*/}
      {/*            />*/}
      {/*        </div>*/}
      {/*    </div>*/}
      {/*)}*/}
    </div>
  );
};

export {Navbar};
